import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import PricingPreview from './components/PricingPreview';
import WhyUsSection from './components/WhyUsSection';
import NewsSection from './components/NewsSection';
import CTASection from './components/CTASection';
import { useSEO } from '@/hooks/useSEO';

export default function HomePage() {
  useSEO({
    title: '台北萬華 iPhone iPad Mac 專業維修',
    description: '兄弟維修位於台北市萬華區，提供 iPhone、iPad、MacBook 專業維修服務，含螢幕更換、電池維修、主板維修、資料救援。Apple IRP 認證，快速完修，立即查詢維修報價！',
    keywords: '手機維修,iPhone維修,iPad維修,MacBook維修,資料救援,台北維修,萬華維修,兄弟維修',
    canonical: '/',
  });

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <WhyUsSection />
        <PricingPreview />
        <NewsSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}
